// extracted by mini-css-extract-plugin
export var appear = "styles-module--appear--g-REn";
export var appearDown = "styles-module--appear-down--f-Xe1";
export var appearLeft = "styles-module--appear-left--gR7h7";
export var appearRight = "styles-module--appear-right--9jDIT";
export var appearUp = "styles-module--appear-up--ISUnD";
export var container = "styles-module--container--1NDLw";
export var desktop = "1340px";
export var giant = "2200px";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var mobile = "400px";
export var nextButton = "styles-module--nextButton--eS9Pv";
export var prevButton = "styles-module--prevButton--7LZDU";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var tablet = "769px";